import { compose, withStateHandlers, pure, withHandlers, setPropTypes } from 'recompose';
import { GridApi, GridReadyEvent, CellFocusedEvent, SelectionChangedEvent } from 'ag-grid';
import { GridProps, propTypes, EnhancedProps, HandlerProps, StateHandlerProps } from './props';
import { State } from './state';
import Grid from './component';
import { createDefaults } from './types';
import container from './container';

const selectAndScrollToRow = (api: GridApi, rowId: string) => {
  const rowNode = api.getRowNode(rowId);
  if (rowNode) {
    rowNode.setSelected(true);
    api.ensureNodeVisible(rowNode);
  }
};

const initProps = (props: GridProps) => {
  let options = createDefaults(props.rowId);
  options.suppressDragLeaveHidesColumns = true;
  options.suppressMovableColumns = true;
  options.enableSorting = false;
  if (options.columnTypes) {
    options.columnTypes.actionsColumn.cellRendererParams = [
      { icon: 'icons/edit.svg', callback: props.onEditRow }
    ];
    options.columnTypes.linkColumn.cellRendererParams = { callback: props.onEditRow };
  }
  return options;
};

export default compose<EnhancedProps, GridProps>(
  container,

  setPropTypes(propTypes),

  withStateHandlers<State, StateHandlerProps, GridProps>(
    (props) => ({ options: initProps(props) }), {}),

  withHandlers<EnhancedProps, HandlerProps>({
    onGridReady: (props) => (event: GridReadyEvent) => {
      event.api.setGridAutoHeight(true);
      event.api.sizeColumnsToFit();
      selectAndScrollToRow(event.api, props.selectedRow as string);
    },

    onSelectionChanged: (props) => (event: SelectionChangedEvent) => {
      if (props.onSelectRow) {
        const selectedNodes = event.api.getSelectedNodes();
        if (selectedNodes.length) {
          props.onSelectRow(selectedNodes[0].data[props.rowId].toString());
        } else {
          props.onSelectRow('');
        }
      }
    },

    onCellFocused: (props) => (event: CellFocusedEvent) => {
      props.options.suppressRowClickSelection = event.column &&
        event.column.getColDef().cellRenderer === 'actionsCellRenderer';
    }
  }),

  pure
)(Grid);


// WEBPACK FOOTER //
// ./src/components/user-grid/composer.ts